if (!customElements.get('ingredient-glossary')) {
  class IngredientGlossary extends HTMLElement {
    constructor() {
      super()
      this.boxesFilters = this.querySelectorAll('.boxes-filters .box-filter');
      this.tagsFilters = this.querySelectorAll('.tags-filters .tag-filter');
      this.allBoxFilter = this.querySelector('.boxes-filters .box-filter[data-box="all"]');
      this.allTagFilter = this.querySelector('.tags-filters .tag-filter[data-tag="all"]');
      this.ingredientItems = this.querySelectorAll('#ingredient-list li');
      this.popupModalTriggers = this.querySelectorAll('#ingredient-list li button');

      this.boxesFilters.forEach(boxFilter => boxFilter.addEventListener('click', this.filterByBoxes.bind(this)));
      this.tagsFilters.forEach(tagFilter => tagFilter.addEventListener('click', this.filterByTags.bind(this)));
      this.popupModalTriggers.forEach(popupModalTrigger => popupModalTrigger.addEventListener('click', this.handleModalTrigger.bind(this)));

      this.matchHeightIngredients(this.ingredientItems);
    }

    filterByBoxes(e) {
      this.hideIngredientItems();
      this.setBoxFilterActive(e.target);
      const selectedBox = e.target.dataset.box;
      const [start, end] = e.target.dataset.box.split('-');

      if (selectedBox == 'all') {
        this.ingredientItems.forEach(ingredientItem => ingredientItem.closest('.grid-item').classList.remove('hide'));
      } else {
        this.ingredientItems.forEach((ingredientItem) => {
          const ingredientName = ingredientItem.dataset.name;
          const firstLetter = ingredientName[0].toLowerCase();
          const ingredientItemWrapper = ingredientItem.closest('.grid-item');

          if (this.letterInRange(firstLetter, start, end)) {
            ingredientItemWrapper.classList.remove('hide');
          } else {
            ingredientItemWrapper.classList.add('hide');
          }
        });
      }
    }

    filterByTags(e) {
      this.hideIngredientItems();
      this.setTagFilterActive(e.target);
      const selectedTag = e.target.dataset.tag;

      if (selectedTag == 'all') {
        this.ingredientItems.forEach(ingredientItem => ingredientItem.closest('.grid-item').classList.remove('hide'));
      } else {
        this.ingredientItems.forEach((ingredientItem) => {
          const tagsData = ingredientItem.dataset.tags;
  
          if (tagsData) {
            const tags = tagsData.split(',');
            tags.forEach(tag => {
              const ingredientItemWrapper = ingredientItem.closest('.grid-item');
              if (this.handleizeTag(tag) == selectedTag) {
                ingredientItemWrapper.classList.remove('hide');
              }
            })
          }
        });
      }
    }

    handleModalTrigger(e) {
      const currentTarget = e.target.closest('.ingredient-content');
      $s.openModal(currentTarget.querySelector('.popup-content'), 'ingredient-popup-modal');
    } 

    letterInRange(letter, rangeStart, rangeEnd) {
      const letterDowncase = letter.toLowerCase();
      return letterDowncase >= rangeStart.trim() && letterDowncase <= rangeEnd.trim();
    }

    handleizeTag(tag) {
      return tag.replace(' & ', '-').replace(' and ', '-and-').replace(' ', '-').toLowerCase();
    }

    hideIngredientItems() {
      this.ingredientItems.forEach(ingredientItem => ingredientItem.closest('.grid-item').classList.add('hide'));
    }

    setBoxFilterActive(target) {
      this.boxesFilters.forEach(boxFilter => boxFilter.classList.remove('active'));
      target.classList.add('active');
    }

    setTagFilterActive(target) {
      this.tagsFilters.forEach(tagFilter => tagFilter.classList.remove('active'));
      target.classList.add('active');
    }

    matchHeightIngredients = function (elements) {
      var height = 0;
      elements.forEach(function(e, ix) {
        e.style.minHeight = '';
      });
      elements.forEach(function(e, ix) {
        height = Math.max(height, e.offsetHeight);
      });
      elements.forEach(function(e, ix) {
        e.style.minHeight = height + 'px';
        e.querySelector('.ingredient-content').style.minHeight = height + 'px';
      });
    }
  }
  customElements.define('ingredient-glossary', IngredientGlossary);
}